import { Text, TextType } from 'ui-components/components/text';
import messages from '../messages';
import styles from './style.module.css';

export const ServiceLevelPopoverContent = () => {
  return (
    <div className={styles['popover-content']}>
      <Text className={styles['popover-body']} textType={TextType.Caption} value={messages.serviceLevelPopoverContent} />
    </div>
  );
};
